import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import { FaEnvelope, FaSyncAlt, FaHome } from 'react-icons/fa';
import { authService } from '../../api';
import './EnAttenteVerification.css';

const EnAttenteVerification = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { email, name, message } = location.state || {};
  
  const [resending, setResending] = useState(false);
  const [resendSuccess, setResendSuccess] = useState(false);

  const displayEmail = email;
  const displayName = name;

  useEffect(() => {
    if (!displayEmail) {
      navigate('/inscription');
    }
  }, [displayEmail, navigate]);

  const handleResendVerification = async () => {
    try {
      setResending(true);
      setResendSuccess(false);
      
      const response = await authService.resendVerificationEmail();
      
      if (response.verification_sent) {
        setResendSuccess(true);
        setTimeout(() => setResendSuccess(false), 5000);
      }
    } catch (error) {
      console.error('Erreur renvoi email:', error);
    } finally {
      setResending(false);
    }
  };

  return (
    <div className="en-attente-container">
      <div className="en-attente-card">
        <div className="header-icon">
          <FaEnvelope />
        </div>
        
        <h1>Vérification d'email requise</h1>
        
        <div className="user-info">
          <p>Bonjour <strong>{displayName}</strong>,</p>
          <p>Un email de vérification a été envoyé à :</p>
          <p className="user-email">{displayEmail}</p>
        </div>
        
        <div className="instructions">
          <h3>📋 Procédure à suivre :</h3>
          <ol>
            <li>Ouvrez votre boîte email</li>
            <li>Recherchez l'email de <strong>ETEF Plateforme</strong></li>
            <li>Cliquez sur le bouton <strong>"Vérifier mon email"</strong></li>
            <li>Votre compte sera activé automatiquement</li>
          </ol>
        </div>
        
        <div className="email-not-received">
          <h4>Vous n'avez pas reçu l'email ?</h4>
          <div className="common-solutions">
            <ul>
              <li>Vérifiez votre dossier <strong>Spam / Courrier indésirable</strong></li>
              <li>Ajoutez notre adresse à vos contacts</li>
              <li>Attendez quelques minutes</li>
            </ul>
          </div>
          
          <button 
            onClick={handleResendVerification}
            disabled={resending}
            className="resend-btn"
          >
            {resending ? (
              <>
                <FaSyncAlt className="spinning" />
                <span>Envoi en cours...</span>
              </>
            ) : (
              <>
                <FaEnvelope />
                <span>Renvoyer l'email de vérification</span>
              </>
            )}
          </button>
          
          {resendSuccess && (
            <div className="resend-success-message">
              ✅ Un nouvel email a été envoyé !
            </div>
          )}
        </div>
        
        <div className="action-buttons">
          <button onClick={() => navigate('/')} className="home-btn">
            <FaHome />
            Retour à l'accueil
          </button>
          
        
        </div>
      </div>
    </div>
  );
};

export default EnAttenteVerification;